module.exports = __webpack_public_path__ + "static/media/illustration-empty-state.e6018696.png";